import type { LabelTooltipType } from 'antd/lib/form/FormItemLabel';
import React, { useCallback } from 'react';
import Tooltip from '../Tooltip';
import { convertToTooltipProps } from './utils';

const useRenderTooltip = (tooltip: LabelTooltipType) => {
    const renderTooltip = useCallback(() => {
        const tooltipProps = convertToTooltipProps(tooltip);

        return tooltipProps ? <Tooltip {...tooltipProps} /> : null;
    }, [tooltip]);

    return renderTooltip;
};

export default useRenderTooltip;
